import { queryOptions, useQuery } from '@tanstack/react-query';
import { notifications } from '@/mocks/data';
import { http } from '@/shared/api/http';
import { delay } from '@/shared/api/mock';
import { env } from '@/shared/config/env';
import { notificationsEndpoints } from './endpoints';
import type { Notification } from './types';

const fetchNotifications = async ({ signal }: { signal: AbortSignal }): Promise<Notification[]> => {
  if (env.useMocks) {
    await delay(200);
    return notifications;
  }
  return http.get<Notification[]>(notificationsEndpoints.list, { signal });
};

export const notificationsQuery = () =>
  queryOptions({
    queryKey: ['notifications'],
    queryFn: fetchNotifications,
    // TODO(realtime): invalidate this query from the SignalR notification hub instead of polling.
    refetchInterval: 60_000,
  });

export const useNotifications = () => useQuery(notificationsQuery());
